import useBrandsOfUser from "./useBrandsOfUser";
import { useBrands } from "../../modules/shared-entities";

export default function useCanEditBrand(brand: string) {
    const allBrandsQuery = useBrands();

    const brands = useBrandsOfUser();

    if (brands.includes("*")) return true;
    if (brands.includes(brand)) return true;

    return brands
        .map(
            (
                (id) => allBrandsQuery.data?.brands?.find?.(
                    (brand) => brand.id === id
                )
            )
        )
        .filter(Boolean)
        .map(
            (brand) => brand.legacyID
        )
        .includes(brand);
}
